module.exports = __webpack_public_path__ + "img/458.c35e00df.png";